import { ReactElement } from 'react';
import { useMassUpdateService } from 'ui-builder';
import { SelectForMassUpdateCheckbox } from '../../SelectForMassUpdateCheckbox';

export function useGridItemsFilter(children: ReactElement[]) {
  const massUpdateService = useMassUpdateService();

  const isMassUpdateEnabled = massUpdateService?.isEnabled() || false;

  const isSelectForMassUpdateCheckbox = (child?: ReactElement) => {
    return child?.type === SelectForMassUpdateCheckbox;
  };

  const excludedItems: number[] = [];

  const result: ReactElement[] = [];

  children.forEach((child, index) => {
    const isIncluded = isMassUpdateEnabled
      || !isSelectForMassUpdateCheckbox(child as ReactElement);

    if (isIncluded) {
      result.push(child);
    } else {
      excludedItems.push(index);
    }
  });

  return {
    children: result,
    excludedItems,
  };
}
